import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { Stack } from '@mui/material';

import { useLandingFlow } from '@/features/landingFlow';
import { CreateTeamspaceModal } from '@/features/teamspace';

import { ServerNotificationBanner, useSettingsQuery } from '@/entities/user/currentUser';

import { Loader } from '@/shared/ui/Loader';
// eslint-disable-next-line boundaries/element-types
import { DesktopSidebar } from '../../../sidebar';
import { SContainer } from './styled';

export const MainLayout = () => {
  const { isLandingFlow } = useLandingFlow();
  const { isPending: areSettingsPending } = useSettingsQuery();

  // A reload on /pricing has no cached workspace settings. Wait before library
  // pages interpret default feature flags as denied access and redirect home.
  if (isLandingFlow || areSettingsPending) return <Loader />;

  return (
    <SContainer>
      <DesktopSidebar />
      <Stack flex="1" position="relative">
        <ServerNotificationBanner />
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Stack>
      {/* The sidebar's New Teamspace opens it from every page of the space. */}
      <CreateTeamspaceModal />
    </SContainer>
  );
};
